import { FC } from 'react'
import Image from 'next/image'
import clsx from 'clsx'

import Button from 'components/parts/button/button'

import { buttonIdSoundTurnOn } from 'constants/clickableElementsId'
import { imgPath } from '../../data'
import styles from './translation-sound-button.module.scss'

interface TranslationSoundButtonProps {
  onClick: () => void
  isPaused?: boolean
  modificator?: string
}

const LAUNCH = 'ЗАПУСТИТЬ ТРАНСЛЯЦИЮ'
const ENABLE_SOUND = 'ВКЛЮЧИТЬ ЗВУК'

const TranslationSoundButton: FC<TranslationSoundButtonProps> = ({
  onClick,
  isPaused,
  modificator,
}) => {
  return (
    <div className={clsx(styles.buttonWrapper, modificator)}>
      <Button modificator={styles.buttonStyles} id={buttonIdSoundTurnOn} onClick={onClick}>
        <>
          <Image src={imgPath.volume_white} width="32" height="32" alt="разрешить звук" />
          {isPaused ? LAUNCH : ENABLE_SOUND}
        </>
      </Button>
    </div>
  )
}

export default TranslationSoundButton
